import { UnauthorizedError } from "centrifuge";

import type { components } from "@/shared/api/generated/openapi";

export type RealtimeToken = components["schemas"]["RealtimeTokenOut"];

export const REALTIME_TOKEN_URL = "/api/realtime/token";

// Токен подключения: `GET /api/realtime/token`.
// Пока нет клиента из shared/api (#17), запрос — минимальный fetch с cookie сессии.
// После #17 тело заменяется на `client.GET("/api/realtime/token")`, контракт тот же.
//
// 401/403 — пользователь не вошёл: бросаем `UnauthorizedError`, и centrifuge-js
// переходит в `disconnected` без повторов. Прочие ошибки — обычный `Error`,
// SDK повторит запрос с растущей задержкой.
export const fetchRealtimeToken = async (): Promise<RealtimeToken> => {
  const response = await fetch(REALTIME_TOKEN_URL, {
    credentials: "same-origin",
    headers: { Accept: "application/json" },
  });
  if (response.status === 401 || response.status === 403) {
    throw new UnauthorizedError(`realtime token: ${response.status}`);
  }
  if (!response.ok) {
    throw new Error(`realtime token: ${response.status}`);
  }
  return (await response.json()) as RealtimeToken;
};
